// @file Surface permissions store
import { getVuexStore } from '@@/bits/pinia'
import { isRegistered } from '@@/bits/user_model'
import type { RootState } from '@@/vuexstore/surface/types'
import { GroupByTypes } from '@padlet/arvo'
import { defineStore, storeToRefs } from 'pinia'
import { useSurfaceWishArrangementStore } from 'pinia/surface_wish_arrangement'
import { computed } from 'vue'

export const useSurfacePermissionsStore = defineStore('surfacePermissions', () => {
  const surfaceVuexStore = getVuexStore<RootState>() // For gradual conversion to pinia

  const { wishGroupBy } = storeToRefs(useSurfaceWishArrangementStore())
  const amIOwner = computed<boolean>(() => surfaceVuexStore?.getters.amIOwner)
  const amIRegistered = computed<boolean>(() => isRegistered(surfaceVuexStore?.state.user))
  const canIWrite = computed<boolean>(() => surfaceVuexStore?.getters.canIWrite)
  const canIModerate = computed<boolean>(() => surfaceVuexStore?.getters.canIModerate)
  const isPostable = computed<boolean>(() => surfaceVuexStore?.getters.isPostable)
  const canIDragSections = computed(() => canIModerate.value && wishGroupBy.value === GroupByTypes.Section)
  const isReactable = computed<boolean>(() => surfaceVuexStore?.getters.isReactable ?? false)
  const isCommentable = computed<boolean>(() => surfaceVuexStore?.getters.isCommentable)
  const isRemakeable = computed<boolean>(() => surfaceVuexStore?.getters.isRemakeable)
  const requireApprovalForPosts = computed<boolean>(() => surfaceVuexStore?.getters.requireApproval)
  const visitorsCanModerate = computed<boolean>(
    () => surfaceVuexStore?.getters['wallAccessSettings/visitorsCanModerate'],
  )

  return {
    // getters
    amIOwner,
    amIRegistered,
    canIModerate,
    isPostable,
    canIWrite,
    canIDragSections,
    isReactable,
    isCommentable,
    isRemakeable,
    requireApprovalForPosts,
    visitorsCanModerate,
  }
})
